import { Tag } from 'antd';
import { roleLabel } from '@viq-admin/ui';

/**
 * A user's role as a coloured tag. One colour per customer-plane role, shared
 * by the users list and the user page so a role reads the same on both.
 * antd preset colours, so both themes are handled by the theme itself.
 */
const ROLE_COLOR: Record<string, string> = {
  field_rep: 'green',
  company_admin: 'blue',
  stakeholder: 'gold',
};

export function RoleTag({ role }: { role: string }) {
  return <Tag color={ROLE_COLOR[role] ?? 'default'}>{roleLabel(role)}</Tag>;
}
